import React from 'react';
import { Link } from 'react-router-dom';
export default function NotFound(){return <div className="container" style={{padding:'120px 0 60px', textAlign:'center'}}><h1>404</h1><p>The page you requested was not found.</p><Link to="/">Go Home</Link></div>}
